import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";

export default function TableSkeleton() {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell width={50}>
              <Skeleton height={40} />
            </TableCell>
            <TableCell width={400}>
              <Skeleton height={40} />
            </TableCell>
            <TableCell width={200}>
              <Skeleton height={40} />
            </TableCell>
            <TableCell width={200}>
              <Skeleton height={40} />
            </TableCell>
            <TableCell width={200}>
              <Skeleton height={40} />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              <Skeleton height={40} />
            </TableCell>
            <TableCell align="right">
              <Skeleton height={40} />
            </TableCell>
            <TableCell align="right">
              <Skeleton height={40} />
            </TableCell>
            <TableCell align="right">
              <Skeleton height={40} />
            </TableCell>
            <TableCell align="right">
              <Skeleton height={40} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
